export const ARRIVED = 'ARRIVED';
export const ROUTING_INBOUND = 'ROUTING_INBOUND';
export const ROUTING_OUTBOUND = 'ROUTING_OUTBOUND';
export const RECEIVED = 'RECEIVED';
export const SENT = 'SENT';
export const DELIVERED = 'DELIVERED';
export const ORPHAN = 'ERROR_ORPHAN';
export const ERROR = 'ERROR';
export const ONHOLD = 'ONHOLD';
export const ENROUTE = 'ENROUTE';

export const SOURCE_TYPE_SIMPLR = 'SIMPLR';
export const SOURCE_TYPE_SIMPLR_BOT = 'SIMPLR_BOT';

export const toFriendly = (messageStatus) => {
  switch (messageStatus) {
    case ROUTING_OUTBOUND:
    case SENT:
      return 'SENDING...';
    case ENROUTE:
    case DELIVERED:
      return 'DELIVERED';
    case ERROR:
      return 'FAILED, TRY AGAIN';
    default:
      return '';
  }
};
